export const isReload = (window: Window) => {
  const { performance } = window;
  return (
    performance && performance.navigation && performance.navigation.type === 1
  );
};
